export enum TrackingEvent {
    LoginVisited = 0,
    LoggedIn = 1,
    BuyTicketsVisited = 2,
    BuyPackagesVisited = 3,
    FindDreamTicketsVisited = 4,
    AddToBasket = 5,
    CheckoutStarted = 6,
    CheckoutCompleted = 7,
    FMTAdded = 8,
    CompetitionsVisited = 9,
    WinTicketsVisited = 10,
    AboutVisited = 11,
    WinnerStoriesVisited = 12,
    UpsaleVisited = 13
}
